import React from 'react';
import { Formik, Field } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ChangePasswordValidationSchema } from 'validation/auth/auth-validation';
import { Button, Grid, IconButton, InputAdornment } from '@material-ui/core';
import { FormikInput } from 'shared/material-ui-formik';
import authService from 'services/auth/auth-service';
import { HttpStatusCode } from 'shared/enums/http-status-code';
import { IApplicationState } from 'store/state/app-state';
import messages from 'shared/constants/messages';
import images from 'assets/images';
import { patientPasswordResetSuccess } from 'store/actions/auth-actions';

interface IChangePasswordFormProps {
    handleDialogClose: () => void;
    hideCloseButton?: boolean;
}

const ChangePasswordForm: React.FC<IChangePasswordFormProps> = ({ handleDialogClose, hideCloseButton = false }) => {
    const userData = useSelector((state: IApplicationState) => state.UserData);
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = React.useState({
        current: false,
        new: false,
        confirm: false,
    });

    const handleShowPassword = React.useCallback(
        (name: string, show: boolean) => {
            setShowPassword({ ...showPassword, [name]: show });
        },
        [showPassword],
    );

    const showHidePassword = (name: string, show: boolean) => {
        return (
            <IconButton className="btn" onClick={() => handleShowPassword(name, !show)}>
                <img src={show ? images.icShowPassword : images.icPassword} alt="" />
            </IconButton>
        );
    };

    const initialValues = {
        Password: '',
        ConfirmPassword: '',
        CurrentPassword: '',
        UserIdEnc: userData?.userIdEnc,
    };

    const handleSubmit = (data) => {
        authService
            .changePassword(data)
            .then((response) => {
                if (response?.data?.statusCode === HttpStatusCode.Success) {
                    dispatch(patientPasswordResetSuccess());
                    toast.success(response?.data?.message);
                    handleDialogClose();
                }
            })
            .catch(() => toast.error(messages.SomethingWentWrong));
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={ChangePasswordValidationSchema()}
            validateOnChange={true}
        >
            {(props) => {
                const { handleSubmit } = props;
                return (
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-control-block">
                            <Grid container spacing={3} className="primary-grid patient-info-grid">
                                <Grid item xs={12}>
                                    <div className="form-group">
                                        <Field
                                            label="Current Password"
                                            type={showPassword?.current ? 'text' : 'password'}
                                            name="CurrentPassword"
                                            id="CurrentPassword"
                                            autoComplete="new-password"
                                            component={FormikInput}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {showPassword?.current
                                                            ? showHidePassword('current', true)
                                                            : showHidePassword('current', false)}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="form-group">
                                        <Field
                                            label="New Password"
                                            type={showPassword?.new ? 'text' : 'password'}
                                            name="Password"
                                            id="Password"
                                            autoComplete="new-password"
                                            component={FormikInput}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {showPassword?.new
                                                            ? showHidePassword('new', true)
                                                            : showHidePassword('new', false)}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="form-group">
                                        <Field
                                            label="Confirm New Password"
                                            type={showPassword?.confirm ? 'text' : 'password'}
                                            name="ConfirmPassword"
                                            id="ConfirmPassword"
                                            autoComplete="new-password"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {showPassword?.confirm
                                                            ? showHidePassword('confirm', true)
                                                            : showHidePassword('confirm', false)}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            component={FormikInput}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className="btns-block">
                            <Button variant="contained" color="primary" className="btn" disableElevation type="submit">
                                Save
                            </Button>
                            {!hideCloseButton && (
                                <Button
                                    variant="outlined"
                                    className="btn"
                                    disableElevation
                                    color="primary"
                                    onClick={handleDialogClose}
                                >
                                    Cancel
                                </Button>
                            )}
                        </div>
                    </form>
                );
            }}
        </Formik>
    );
};
export default ChangePasswordForm;
